import * as React from 'react';
import classNames from 'classnames';

import styles from '../less/spinner.module.less';

export declare type SpinnerSize = 72 | 32 | 16;

export interface SpinnerProps extends React.HTMLAttributes<SVGElement> {
  /** Extra custom class name. */
  className?: string;
  /** 72 | 32 | 16 */
  size?: SpinnerSize;
}

export const Spinner: React.FunctionComponent<
  React.PropsWithChildren<SpinnerProps>
> = ({ className = '', size = 16, ...rest }) => {
  const width = size === 16 ? '6' : '3';

  const spinnerClass = classNames(
    styles[`spinner-${size}`],
    styles.spinner,
    className
  );

  return (
    <svg {...rest} className={spinnerClass} viewBox="25 25 50 50">
      <circle
        className={styles.track}
        cx="50"
        cy="50"
        r="20"
        fill="none"
        strokeWidth={width}
        strokeMiterlimit="10"
      />
      <circle
        className={styles.path}
        cx="50"
        cy="50"
        r="20"
        fill="none"
        strokeWidth={width}
        strokeMiterlimit="10"
      />
    </svg>
  );
};
